import React, { memo } from 'react';

import ConstructionTypeFilter from './Filters/ConstructionTypeFilter';
import Content from './General/Content';
import Filters from './General/Filters';
import InterestPerProductTable from './InterestTables/InterestPerProductTable';
import { PRODUCT_FILTERS } from '../../Constants/Interest/Filter';
import SubmitFilter from './Filters/SubmitFilter';

import CombinedLabelAndModificationLoanFormFilter from './Filters/CombinedLabelAndModificationLoanFormFilter';

const InterestPerProduct: React.FC = () => (
    <div className="interest-content-wrapper" data-testid="interest-per-product">
        <Filters>
            <SubmitFilter filterProperties={PRODUCT_FILTERS} />
            <hr />
            <CombinedLabelAndModificationLoanFormFilter />
            <hr />
            <ConstructionTypeFilter />
        </Filters>
        <Content>
            <InterestPerProductTable />
        </Content>
    </div>
);

export default memo(InterestPerProduct);
